export default {
  getRentPreRegistrations: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registrations/getters.js